import React from "react";
import styled from "styled-components";
import bottomImage from "../../assets/images/bottom_banner.jpg";
import mBottomImage from "../../assets/images/m_banner.jpg";
import Btn from "../atoms/Btn";
import {useNavigate} from "react-router-dom";
import {device} from "../../assets/styles/media";

const Contents = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 370px;
    background: url(${bottomImage}) 0 0 no-repeat;
    background-size: cover;
    text-align: center;

    ${device.tablet} {
        padding: 78px 20px 64px;
        box-sizing: border-box;
        background: url(${mBottomImage}) 0 0 no-repeat;
        background-size: 100% 100%;
    }
    ${device.mobile} {
        background: url(${mBottomImage}) 0 0 no-repeat;
        background-size: 100% 100%;
        height: 250px;
    }
`;
const Title = styled.strong`
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    
    ${device.mobile} {
        font-size: 16px;
        padding-top: 10px;
    }
`;
const Desc = styled.p`
    padding-top: 16px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 10px;

    ${device.tablet} {
        padding-top: 20px;
        font-size: 17px;
        line-height: 1.8;
        margin-bottom: 25px;
    }

    ${device.mobile} {
        padding-top: 10px;
        font-size: 13px;
    }
`;

const BottomContents = () => {
    const navigate = useNavigate();
    return (
        <Contents>
            <Title>자연을 담은 강아지숲 이야기</Title>
            <Desc>
                국내 최대 규모의 반려견 테마파크인 강아지숲의<br/>
                자연과의 공존을 이야기하는 탄생 스토리
            </Desc>
            <Btn
                onClick={() => navigate("/notice/dstory")}
                color={"transparent"}
                border={"1px solid #fff"}
                mt={20}
                text="자세히보기"/>
        </Contents>
    );
};

export default BottomContents;
